import axios from 'axios'
import { Image, Input, Modal, ScrollView, Select, Text, Tooltip } from 'native-base'
import { Avatar, Box, Button, HStack, VStack } from 'native-base'
import { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import Wrapper from '../../components/Wrapper'
import { baseApi } from '../../utils/api'
import { API_URL } from '../../utils/env'
import { TouchableOpacity } from 'react-native'
import {
  ColumnDef,
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from '@tanstack/react-table'
import PdfIcon from '../../components/Icons/PdfIcon'
import RolesEnum from '../../utils/interfaces/RolesEnum'
import jwtDecode from 'jwt-decode'
import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import getTranslateDataType from './utils/getTranslateDataType'
import { validateDate } from '../../utils/functions'
import { position } from 'native-base/lib/typescript/theme/styled-system'

function CrearRecursos() {
  const [form, setForm] = useState({
    name: '',
    cime: '',
    cime_date: '',
    fabricator: '',
    model: '',
    acquisition_date: '',
    serie: '',
    year: '',
    weight: '',
    depot_id: '',
    observations: '',
    image: {
      url: '',
      alt: '',
      name: '',
    },
    resourceImages: [],
    resourceDocuments: [],
  })
  const [formDocAsoc, setFormDocAsoc] = useState<any>({
    name: '',
    document_type_id: '',
    resource_id: '',
    file: [],
    period: '',
    review_date: '',
    responsible: '',
  })
  const [newId, setNewId] = useState(null)
  const [mainImage, setMainImage] = useState<File | null>(null) // Estado único para imagen principal
  const [images, setImages] = useState<any>([]) // Solo imágenes secundarias
  const [documentType, setDocumentType] = useState([])
  const [delegations, setDelegations] = useState([])
  const [dataTable, setDataTable] = useState<any[]>([])
  const [userList, setUserList] = useState<any>([])
  const [isLoading, setIsLoading] = useState(false)
  const [usuarios, setUsuarios] = useState<any>([])
  const [modalVisible, setModalVisible] = useState(false)
  const [modalCreate, setModalCreate] = useState(false)
  const [resourcesTypes, setResourcesTypes] = useState<any>([])
  const [resource, setResource] = useState<any>([])
  const [nameResource, setNameResource] = useState('')
  const [labelType, setLabelType] = useState('')

  const refSearch = useRef<HTMLInputElement>(null)
    const token = localStorage.getItem('token')
  let roles = [0]
  if (token) {
    const { userData }: any = jwtDecode(token as string)
    roles = userData.userRole.map((v: any) => v.role_id)
  }
  const columnHelper = createColumnHelper<any>()

  const navigate = useNavigate()

  const inputImageMainRef = useRef<HTMLInputElement>(null);
  const inputImages = useRef<HTMLInputElement>(null);

  const abrirInput = (param: number) => { // 1= main, 2 = extra
    if(param === 1 ){
      if (inputImageMainRef.current == null) return;
      inputImageMainRef.current.click();   // abre el input
      inputImageMainRef.current.focus();   // le da foco
    } else {
      if (inputImages.current == null || images.length >= 4) {
        alert('Solo se pueden subir 4 imágenes adicionales como máximo.');
        return;
      }
      inputImages.current.click();   // abre el input
      inputImages.current.focus();   // le da foco
    }
    
  };
  const getDelegaciones = async () => {
    setIsLoading(true)
    let url = '';
			if(roles.includes(RolesEnum.Admin)){
				url = 'depot/all'
			}
			if(roles.includes(RolesEnum.ResponsableAlmacen)){
				url = 'user/get/depots'
			}
    try {
      const { data } = await baseApi.get(url, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        },
      })
      setDelegations(data)
    } catch (error) {
      alert('Error al cargar las delegaciones')
    } finally {
      setIsLoading(false)
    }
  }
  const getDocumentType = async () => {
    setIsLoading(true)

    try {
      const { data } = await baseApi.get(`/document-type/all`, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        },
      })
      setDocumentType(data)
    } catch (error) {
      alert('Error al cargar los tipos de documentos')
    } finally {
      setIsLoading(false)
    }
  }
  const getResourceType = async () => {
    setIsLoading(true)

    try {
      const { data } = await baseApi.get(`/resource-type/all`, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        },
      })
      const newData = getTranslateDataType(data)
      setResourcesTypes(newData)
    } catch (error) {
      alert('Error al cargar los tipos de recursos')
    }
    setIsLoading(false)
  }

  const getResourceAll = async () => {
    
    try {
      setIsLoading(true)
      const { data } = await baseApi.get(`/resource/all`, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        },
      })
      setResource(data)
    } catch (error) {
        alert('Error al cargar los recursos')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getDelegaciones()
    getDocumentType()
    getResourceType()
    getResourceAll()
  }, [])
  const createCentro = async () => {
    try {
      if(form.name === '' || form.serie === '' || form.year === '' || form.depot_id === ''){
        alert('Por favor, rellene los campos obligatorios (nombre, número de serie, año de fabricación y almacén)')
        return false
      }
      setIsLoading(true)
      var newForm = new FormData()
      newForm.append('name', form.name)
      newForm.append('cime', form.cime)
      newForm.append('cime_date', form.cime_date)
      newForm.append('fabricator', form.fabricator)
      newForm.append('model', form.model)
      newForm.append('serie', form.serie)
      newForm.append('acquisition_date', form.acquisition_date)
      newForm.append('year', form.year)
      newForm.append('weight', form.weight)
      newForm.append('status', "1")
      newForm.append('depot_id', form.depot_id)
      newForm.append('observations', form.observations)

      // if ((form.image !== null && form.image !== undefined)|| form.resourceImages.length > 0 || form.resourceDocuments.length > 0) {
      //   let image = {
      //     image : form.image,
      //     extraImages: form.resourceImages,
      //     resourceDocument: form.resourceDocuments
      //   }
      //   newForm.append('image', JSON.stringify(image))
      // }

      // if(images.length > 0){
      //   newForm.append("image", images[0]!, images[0] ? images[0].name : "");
      //   if(images.length > 1) {
      //     images.map((img: any, i: any) => {
      //       if(0 === i){
      //         return false;
      //       }
      //       newForm.append("extra_image[]", img!, img ? img.name : "");
      //       return false;
      //     })
      //   }
      // }

      // Manejar imágenes nuevas (archivos subidos)
      let hasNewMainImage = mainImage !== null;
      let hasNewSecondaryImages = images.length > 0;
      
      // Si hay imagen principal nueva, enviarla como archivo
      if(hasNewMainImage && mainImage){
        newForm.append("image", mainImage, mainImage.name || "");
      }

      // Enviar imágenes secundarias nuevas (todo el array images ahora solo contiene secundarias)
      if(hasNewSecondaryImages) {
        images.forEach((img: any) => {
          if(img){
            newForm.append("extra_image[]", img, img.name || "");
          }
        });
      }

      // Preparar JSON con imágenes clonadas que se mantienen
      // Solo incluir imagen principal clonada si NO hay imagen nueva
      let clonedImage = null;
      if(!hasNewMainImage && form.image && form.image.url) {
        clonedImage = form.image;
      }

      // Incluir imágenes secundarias clonadas (las que no se eliminaron)
      let clonedSecondaryImages = form.resourceImages || [];

      // Incluir documentos clonados si existen
      let clonedDocuments = form.resourceDocuments || [];

      // Enviar JSON solo si hay algo que clonar (imágenes o documentos)
      if(clonedImage || clonedSecondaryImages.length > 0 || clonedDocuments.length > 0) {
        let imageData = {
          image: clonedImage,
          extraImages: clonedSecondaryImages,
          resourceDocument: clonedDocuments
        }
        newForm.append("cloned_images", JSON.stringify(imageData))
      }
			
      const { data, status } = await baseApi.post(`${API_URL}/resource/create`, newForm, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
          "Content-Type": "multipart/form-data",
        },
      })

      if(status >= 200) {
        setNewId(data.id)
        setModalCreate(true)
      }
      setIsLoading(false)
      // navigate(`/recursos/editar/${data.id}`)
    } catch (error) {
      alert('Error al crear el recurso, por favor intente de nuevo.')
      setIsLoading(false)
    } finally {      
      setIsLoading(false)
    }
  }
  const createDoc = async () => {
    try {
      setIsLoading(true)
      var newForm = new FormData()
      newForm.append('name', formDocAsoc.name)
      newForm.append('document_type_id', formDocAsoc.document_type_id)
      newForm.append('resource_id', !!newId ? (newId! as number).toString() : '0')
      newForm.append('period', formDocAsoc.period)
      newForm.append('review_date', formDocAsoc.review_date)
      newForm.append('responsible', formDocAsoc.responsible)
      newForm.append("file", formDocAsoc.file!, formDocAsoc.file ? formDocAsoc.file.name : "");
			
      const { data } = await baseApi.post(`${API_URL}/resource-document/create`, newForm, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
          "Content-Type": "multipart/form-data",
        },
      })

      let datatableall: any[] = []

      datatableall = [...datatableall, {
      id: data.id,
      type: data.documentType.name,
      name: data.name,
      period: `${data.period} meses`,
      date_next_review: data.review_date,
      responsable: 'Almacén',
      document: (
        <TouchableOpacity style={{ alignItems: 'center' }}>
          <PdfIcon />
        </TouchableOpacity>
      ),
      actions: (
        <div className='d-flex'>
          {/* <TouchableOpacity style={{ paddingHorizontal: 1 }}>
            <i className='bx bx-pencil bx-sm'></i>
          </TouchableOpacity> */}
          <TouchableOpacity style={{ paddingHorizontal: 1 }}>
            <i className='bx bx-trash bx-sm'></i>
          </TouchableOpacity>
        </div>
      ),
      }]
      setDataTable(datatableall)
      // if(status === 200) setNewId(data.id)
      // navigate('/recursos')
      // setIsLoading(false)
      setFormDocAsoc({
        name: '',
        document_type_id: '',
        resource_id: '',
        file: [],
        period: '',
        review_date: '',
        responsible: '',
      })
    } catch (error) {
      alert('Error al crear el documento asociado, por favor intente de nuevo.')
    }
    setIsLoading(false)
  }

  const closeModal = () => {
    setNameResource('');
    refSearch.current && (refSearch.current.value = '');
    setModalVisible(false);
  }

  const selectResource = (res: any) => {
    setForm({
      name: res.name,
      cime: res.cime,
      cime_date: res.cime_date? res.cime_date.split('T')[0] : '',
      fabricator: res.fabricator,
      model: res.model,
      acquisition_date: res.acquisition_date ? res.acquisition_date.split('T')[0] : '',
      serie: res.serie,
      year: res.year,
      weight: res.weight,
      depot_id: res.depot.id,
      observations: res.observations,
      image: res.image,
      resourceImages: res.resourceImage || [],
      resourceDocuments: res.resourceDocument || []
    })
    // Limpiar imagen principal nueva al clonar (mantener solo la clonada en form.image)
    setMainImage(null);
    setModalVisible(false);
  }

  return (
    <>
      <Modal
          style={{ height: '100%', zIndex: 99999, position: 'absolute' }}
          isOpen={modalCreate}
          onClose={() => setModalCreate(false)}
        >
          <Modal.Content style={{ zIndex: 99999 }}>
            <Modal.CloseButton />
            <Modal.Header>Recurso creado correctamente.</Modal.Header>
            <Modal.Footer>
              <Button.Group space={2}>
                <Button
                  colorScheme='success'
                  onPress={() => {
                    // que habra en otra pestania el recurso creado
                    window.open(`/recursos/ver/qr/${newId}`, '_blank');
                  }}
                  // qr icon
                  leftIcon={<i className="bx bx-barcode bx-sm text-white"></i>}
                >
                  Ver código QR
                </Button>
                <Button
                  leftIcon={<i className="bx bx-file bx-sm text-white"></i>}
                  onPress={() => {
                    window.open(`/recursos/editar/${newId}`, '_blank');
                  }}
                >
                  Agregar documentos
                </Button>
              </Button.Group>
            </Modal.Footer>
          </Modal.Content>
      </Modal>
      <Wrapper title='Crear recursos' subtitle=''>
        
        <div className='page-wrapper'>
          <div className='page-content'>
            <div className='row'>
              <div className='col-xl-12 mx-auto'>
                <hr />
                <div className='card'>
                  <div className='card-body'>
                    <div className='row g-3'>
                      <div className='col-md-12 mb-3'>
                        <div>
                          <label className='form-label'>
                            Nombre del recurso a duplicar: 
                          </label>
                          <Input
                            ref={refSearch}
                            value={nameResource}
                            onChangeText={(value) =>{
                                setNameResource(value)
                                setModalVisible(true)
                              }
                            }
                            type='text'
                            className='form-control'
                            placeholder=''
                          />
                        </div>
                        {
                          nameResource.length > 3 && modalVisible &&
                          <div className='col-md-12 mb-3 d-flex align-items-end mt-2' style={{ position:'relative', height: '40px'}}>
                            <div className='col-md-12 top-0 left-0 absolute max-height-100 rounded' 
                              style={{backgroundColor: '#ebebebea', position: 'absolute', padding: '10px', zIndex:100 , maxHeight: '250px', overflowY: 'auto', border: '1px solid gray'}}
                            >
                              {
                                resource.filter((r: any) => r.name.toLowerCase().includes(nameResource.toLowerCase())).map((res: any, index: number) => (
                                  <div key={index} style={{margin: '15px'}}>
                                    <Button variant='outline' colorScheme='secondary' onPress={() => selectResource(res)}
                                      bg={'white'} display={'flex'} alignItems={'center'} justifyContent={'flex-start'} width={'100%'}
                                    >
                                      <span style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                                        {
                                          res.image?.url && <img src={res.image?.url} alt={res.name} style={{ width: '42px', height: '42px', marginRight: '10px' } }/>
                                        }
                                        <p style={{marginRight: '10px'}}>{res.name} - {res.serie}</p>
                                      </span>
                                    </Button>
                                  </div>
                                ))
                              }
                              <Button variant='solid' colorScheme='danger' onPress={()=>closeModal()}>
                                Cerrar
                              </Button>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className='card'>
                  <div className='card-body'>
                    <form className='row g-3'>
                      <div className='col-md-3 mb-1'>
                        <label className='form-label'>Fecha de alta Cime:</label>
                        <input
                          value={form.cime_date}
                          disabled={!!newId}
                          onChange={(event) => {
                            if (validateDate(event.target.value, "1999-01-01", new Date().toISOString().split("T")[0])) {
                              setForm({ ...form, cime_date: event.target.value });
                            } else {
                              alert("Fecha no válida");
                              setForm({ ...form, cime_date: "" }); // Borra el valor incorrecto
                            }
                          }}
                          type='date'
                          className='form-control'
                          placeholder=''
                          min="1999-01-01" // Fecha mínima (1 de enero de 2000)
                          max={new Date().toISOString().split("T")[0]} // Fecha máxima: Hoy
                        />
                      </div>
                      <div className='border py-1 px-2 rounded border-primary col-md-8 w-full'
                        style={
                          {
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            
                        }}

                      >
                        <div className='col-md-6 col-lg-6 w-full'>
                          <span
                            className='d-flex justify-content-start align-items-center'
                          >
                            <label className='form-label pt-1'
                              style={{marginRight: '10px'}}
                            >Buscar Tipo:</label>
                            <span className='ml-4 bg-info rounded px-2 '>
                              <Tooltip 
                                label=" Seleccionar un tipo de recurso, no es posible seleccionar un tipo padre. Ademas puede escrbir el nombre del tipo de recurso para buscarlo." 
                                openDelay={50}
                                closeDelay={200}
                                bg={'gray.800'}
                                w={'300px'}
                              >
                                <i className="text-white fs-5 bx bx-info-circle" style={{cursor:'pointer'}}></i>
                              </Tooltip>
                            </span>
                          </span>
                            <div className=''>
                            <DropdownTreeSelect  
                            texts={{
                              placeholder:'Seleccionar',
                              noMatches:'No hay resultados',
                              label:form.cime,
                            }} 
                            keepTreeOnSearch  
                            onChange={(v:any,a: any) => {
                              setForm({ ...form, cime: v.value });
                              setLabelType(v.label)
                            }} 
                            mode='radioSelect'  
                            data={resourcesTypes} 
                            className='w-full' />
                            </div>
                        </div>
                        <div className='col-md-6 col-lg-6 w-full'>
                          <label className='form-label'>Código CIME:</label>
                          <Input
                            value={form.cime}
                            isDisabled={!!newId}
                            onChangeText={(value) =>
                              setForm({ ...form, cime: value })
                            }
                            type='text'
                            className='form-control'
                            placeholder=''
                          />
                          <p
                            style={{
                              color: 'gray',
                              fontSize: 12,
                              fontStyle: 'italic',
                            }}  
                          >Nombre: {labelType}</p>
                        </div>
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>
                          Nombre de la maquina:
                        </label>
                        <Input
                          value={form.name}
                          isDisabled={!!newId}
                          onChangeText={(value) =>
                            setForm({ ...form, name: value })
                          }
                          type='text'
                          className='form-control'
                          placeholder=''
                        />
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>Modelo:</label>
                        <Input
                          isDisabled={!!newId}
                          value={form.model}
                          onChangeText={(value) =>
                            setForm({ ...form, model: value })
                          }
                          type='text'
                          className='form-control'
                          placeholder=''
                        />
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>Nº de Serie:</label>
                        <Input
                          value={form.serie}
                          disabled={!!newId}
                          onChangeText={(value) =>
                            setForm({ ...form, serie: value })
                          }
                          type='text'
                          className='form-control'
                          placeholder=''
                          isDisabled={!!newId}
                        />
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label className='form-label'>Año de fabricación:</label>
                        {/* <input
                          value={form.year}
                          disabled={!!newId}
                          onChange={(event) => {
                            if(validateDate(event.target.value, "2000-01-01", new Date().toISOString().split("T")[0])){
                              setForm({ ...form, year: event.target.value });
                              // setForm({ ...form, year: new Date(event.target.value).getFullYear().toString()})
                            } else {
                              alert("Fecha no válida");
                              setForm({ ...form, year: "" });
                            }
                          }}
                          type='date'
                          className='form-control'
                          placeholder=''
                          min="2000-01-01" 
                          max={new Date().toISOString().split("T")[0]} 
                        /> */}
                        <select
                          value={form.year}
                          disabled={!!newId}
                          onChange={(e) => setForm({ ...form, year: e.target.value })}
                          className="form-control"
                        >
                          <option value="">Selecciona un año</option>
                          {Array.from({ length: new Date().getFullYear() - 1999 }, (_, i) => 2000 + i).map((year) => (
                            <option key={year} value={year}>{year}</option>
                          ))}
                        </select>
                      </div>
                      <div className='col-md-2 mb-1'>
                        <label className='form-label'>Peso:</label>
                        {/* <Input
                          value={form.weight}
                          isDisabled={!!newId}
                          onChangeText={(value) =>{
                            let weight = value.replace(/[^0-9]/g, '');
                            setForm({ ...form, weight: weight })
                          }}
                          type='text'
                          className='form-control'
                          placeholder=''
                        /> */}
                        <Input
                          value={form.weight}
                          isDisabled={!!newId}
                          onChangeText={(value) => {
                            // Solo permite números y UNA coma (ej: "80", "80,5")
                            const regex = /^\d{0,6}(,\d{0,2})?$/;

                            if (regex.test(value)) {
                              setForm({ ...form, weight: value });
                            }
                          }}
                          type='text'
                          className='form-control'
                        />

                      </div>

                      <div className='col-md-6 mb-3'>
                        <label htmlFor='center_id' className='form-label'>
                          Almacén:
                        </label>
                        <Select
                          nativeID='center_id'
                          isDisabled={!!newId}
                          onValueChange={(value) =>
                            setForm({ ...form, depot_id: value })
                          }
                          selectedValue={form.depot_id.toString()}
                        >
                          <Select.Item value='' label='Escoger...' />
                          {delegations.map((centers: any) => (
                            <Select.Item
                              key={centers.id}
                              value={centers.id.toString()}
                              label={centers.name}
                            />
                          ))}
                        </Select>
                      </div>

                      <div className='col-md-4 mb-1'>
                        <label className='form-label'>Fabricante:</label>
                        <Input
                          value={form.fabricator}
                          isDisabled={!!newId}
                          onChangeText={(value) =>
                            setForm({ ...form, fabricator: value })
                          }
                          type='text'
                          className='form-control'
                          placeholder=''
                        />
                      </div>
                      <div className='col-md-8 mb-3'>
                        <label className='form-label'>Observaciones:</label>
                        <Input
                          value={form.observations}
                          isDisabled={!!newId}
                          onChangeText={(value) =>
                            setForm({ ...form, observations: value })
                          }
                          type='text'
                          className='form-control'
                          placeholder=''
                        />
                      </div>
                      <div className='col-md-4 mb-3'>
                        <label className='form-label'>Fecha de Adquisición:</label>
                        <input
                          disabled={!!newId}
                          value={form.acquisition_date}
                          onChange={(value) =>{
                            if(validateDate(value.target.value, "1999-01-01", new Date().toISOString().split("T")[0])){
                              setForm({ ...form, acquisition_date: value.target.value })
                            } else {
                              alert("Fecha no válida");
                              setForm({ ...form, acquisition_date: "" });
                            }
                          }}
                          type='date'
                          className='form-control'
                          placeholder=''
                          min="1999-01-01" // Fecha mínima (1 de enero de 2000)
                          max={new Date().toISOString().split("T")[0]} // Fecha máxima: Hoy
                        />
                      </div>
                      <div className='col-md-4'
                        style={{
                          borderRight: '2px solid #cccccc',
                          marginRight: '0px',
                        }}
                      >
                        <label className='form-label'>Foto Principal:</label>
                        <div className='row g-3 m-2' style={{
                          position:'relative', 
                          backgroundColor:'#eeeeee', 
                          minWidth: '100px', 
                          minHeight: '200px', 
                          display: 'flex', 
                          justifyContent: 'center', 
                          alignItems: 'center',
                          borderRadius: '5px',
                          borderWidth: '1px',
                          borderStyle: 'dashed',
                        }}>

                          {
                            mainImage ? 
                            <div className='col-12'>
                              <Image
                                width={300}
                                height={300}
                                source={{
                                  uri: URL.createObjectURL(mainImage)
                                }}
                              />
                            </div> 
                            : form.image?.url &&
                            <div className='col-12'>
                              <div className='col-12'>
                                <Image
                                  width={300}
                                  height={300}
                                  source={{
                                    uri: encodeURI(form.image?.url)
                                  }}
                                />
                              </div> 
                            </div>
                          }

                          {/* {
                            form.image?.url &&
                            <div className='col-12'>
                              <Image
                                width={300}
                                height={300}
                                source={{
                                  uri: encodeURI(form.image?.url)
                                }}
                              />
                            </div> 
                          }
                          {images.map((image: any, index: number) => {
                            if (index === 0) {
                              return (
                                <div className='col-12'>
                                  <Image
                                    width={300}
                                    height={300}
                                    source={{
                                      uri: URL.createObjectURL(image)
                                    }}
                                  />
                                </div> 
                              )
                            }
                            return false
                          })} */}

                          <p
                            onClick={() => abrirInput(1)}
                            style={{
                              fontSize: 14,
                              fontStyle: 'italic',
                              position: 'absolute',
                              backgroundColor: '#202020a1',
                              right: '40%',
                              top: '30%',
                              width: '20%',                              
                              padding: '5px',
                              borderRadius: '5px',
                              cursor: 'pointer',
                              textAlign: 'center',
                              color: 'white',

                            }}
                          >
                            <i className="bx bx-upload bx-sm text-white"></i>{' '}
                            {
                              !mainImage && !form.image?.url ? 'Subir' : 'Editar'
                            }
                          </p>
                          <input
                            ref={inputImageMainRef}
                            type="file"
                            style={{ display: 'none' }}
                            aria-label=""
                            onChange={(e) => {
                              let file = e.target.files ? e.target.files[0] : null;
                              if (file) {
                                // Actualizar solo la imagen principal, no afectar images (secundarias)
                                setMainImage(file);
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className='col-md-8 mb-3'>
                        <input
                          disabled={!!newId}
                          ref={inputImages}
                          style={{ display: 'none' }}
                          aria-label='Subir Foto'
                          onChange={(e) => {
                            let file = e.target.files ? e.target.files[0] : null;
                            if (file) {
                              let newImages = [...images];
                              // agregar al final del array (después de la imagen principal si existe)
                              newImages.push(file);
                              setImages(newImages);
                            }
                          }}
                          type='file'
                          className='form-control'
                        />

                        <div className='col-md-12 mt-2' style={{marginLeft: '12px'}}>
                          <label className='form-label'>Fotos Secundarias:</label>
                          <div className='row g-3'>
                            
                            {
                              form.resourceImages.map((image: any, index: number) => {
                                return (
                                  <div className='col-4' key={index} style={{position:'relative'}}>
                                    <Image
                                      width={200}
                                      height={200}
                                      source={{ uri: encodeURI(image?.image?.url) }}
                                    />
                                    <i
                                      className="bx bx-trash bx-md"
                                      style={{
                                        position: 'absolute',
                                        top: '40%',
                                        right: '40%',
                                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        paddingRight: '4px',
                                        paddingLeft: '4px',
                                      }}
                                      onClick={() => {
                                        let newResourceImages = form.resourceImages.filter((_: any, i: number) => i !== index);
                                        setForm({ ...form, resourceImages: newResourceImages });
                                      }}
                                    ></i>
                                  </div>
                                )
                              })
                            }

                            {images.map((image: any, index: number) => {
                              return (
                                <div className='col-4' key={`secondary-${index}`} style={{position:'relative'}}>
                                  <Image
                                    width={200}
                                    height={200}
                                    source={{ uri: URL.createObjectURL(image) }}
                                  />
                                  <i
                                      className="bx bx-trash bx-md"
                                      style={{
                                        position: 'absolute',
                                        top: '40%',
                                        right: '40%',
                                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        paddingRight: '4px',
                                        paddingLeft: '4px',
                                      }}
                                      onClick={() => {
                                        let newImages = images.filter((_: any, i: number) => i !== index);
                                        setImages(newImages);
                                      }}
                                    ></i>

                                </div>
                              )
                            })}

                            <div
                              style={{
                                width: '200px',
                                height: '200px',
                                backgroundColor:'#eeeeeeff',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer',
                                borderRadius: '5px',
                                borderWidth: '1px',
                                borderStyle: 'dashed',
                                borderColor: 'gray',
                              }}
                              onClick={() => abrirInput(2)}
                            >
                              {/* icon de añadir, subir o subir foto */}
                              <i
                                onClick={() => abrirInput(2)}
                                className="bx bx-plus bx-lg"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-3 offset-9 mb-3'>
                        <Button
                          
                          color={'success.400'}
                          isLoading={isLoading}
                          onPress={() => createCentro()}
                        >
                          Guardar
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
                {/* <div className='card'>
                  <div className='card-body'>
                    <div className='dropdown' style={{ width: '70%' }}>
                      <HStack alignItems='center' space={3}>
                        <VStack>
                          <Text
                            fontSize={24}
                            fontWeight={'bold'}
                            color='primary.500'
                            _dark={{
                              color: 'primary.500',
                            }}
                          >
                            Documentos Asociados
                          </Text>
                        </VStack>
                      </HStack>
                    </div>
                    <div className='row g-3'>
                      <div className='col-md-12'>
                        <Table data={dataTable} columns={columns} />
                      </div>
                      <hr></hr>
                      <div className='col-md-6'>
                        <div className='col-md-12 mb-3'>
                        <label className='form-label'>Nombre:</label>
                        <Input
                        isRequired
                          value={formDocAsoc.name}
                          isDisabled={!newId}
                          onChangeText={(value) =>
                            setFormDocAsoc({ ...formDocAsoc, name: value })
                          }
                          type='text'
                          className='form-control'
                          placeholder=''
                        />
                      </div>
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label htmlFor='document_type_id' className='form-label'>
                          Tipo:
                        </label>
                        <Select
                          nativeID='document_type_id'
                          isDisabled={!newId}
                          onValueChange={(value) =>
                            setFormDocAsoc({ ...formDocAsoc, document_type_id: value })
                          }
                          selectedValue={formDocAsoc.document_type_id.toString()}
                        >
                          <Select.Item value='' label='Escoger...' />
                          
                          {documentType.map((centers: any) => (
                            <Select.Item
                              key={centers.id}
                              value={centers.id.toString()}
                              label={centers.name}
                            />
                          ))}
                        </Select>
                      </div>
                      <div className='col-md-3 mb-3'>
                        <label htmlFor='responsible' className='form-label'>
                          Responsable:
                        </label>
                        <Select
                          nativeID='responsible'
                          isDisabled={!newId}
                          onValueChange={(value) =>
                            setFormDocAsoc({ ...formDocAsoc, responsible: value })
                          }
                          selectedValue={formDocAsoc.responsible.toString()}
                        >
                          <Select.Item value='' label='Escoger...' />
                            <Select.Item
                              key={'5'}
                              value={'5'}
                              label={'Almacén'}
                            />
                            <Select.Item
                              key={'3'}
                              value={'3'}
                              label={'Coordinador'}
                            />
                        </Select>
                      </div>
                      <div className='col-md-4 mb-3'>
                        <label className='form-label'>Periodo en meses:</label>
                        <Input
                          value={formDocAsoc.period}
                          isDisabled={!newId}
                          onChangeText={(value) =>
                            setFormDocAsoc({ ...formDocAsoc, period: value })
                          }
                          type='text'
                          className='form-control'
                          placeholder=''
                        />
                      </div>
                      <div className='col-md-4 mb-3'>
                        <label className='form-label'>Fecha Última Revisión:</label>
                        <input
                          disabled={!newId}
                          value={formDocAsoc.review_date}
                          onChange={(value) =>
                            setFormDocAsoc({ ...formDocAsoc, review_date: value.target.value })
                          }
                          type='date'
                          className='form-control'
                          placeholder=''
                        />
                      </div>
                      <div className='col-md-4 mb-3'>
                        <label className='form-label'>Subir Documento:</label>
                        <input
                          disabled={!newId}
                          onChange={(event: any) => {
                            if (formDocAsoc.file.length < 2) {
                              setFormDocAsoc({...formDocAsoc, file: event.target.files[0]})
                            }
                          }}
                          type='file'
                          className='form-control'
                        />
                        </div>
                        <div className='col-md-3 offset-9 mb-3'>
                        <Button
                          isDisabled={!newId}
                          color={'success.400'}
                          isLoading={isLoading}
                          onPress={() => createDoc()}
                        >
                          Añadir
                        </Button>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  )
}
function Table({ data, columns }: { data: any[]; columns: ColumnDef<any>[] }) {
  const table = useReactTable({
    data,
    columns,
    // Pipeline
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    //
    debugTable: false,
  })

  useEffect(() => {
    table.setPageSize(5)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className='p-2 table-responsive bg-white'>
      <table className='table  table-dark'>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th key={header.id} colSpan={header.colSpan}>
                    {header.isPlaceholder ? null : (
                      <div className='center text-center'>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                        {header.column.getCanFilter() ? (
                          <div>
                            {/* <Filter column={header.column} table={table} /> */}
                          </div>
                        ) : null}
                      </div>
                    )}
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody className='table-light fst-normal'>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr className='fst-normal' key={row.id + 'tr'}>
                {row.getVisibleCells().map((cell: any) => {
                  return (
                    <td className='fst-normal text-center' key={cell.id + 'td'}>
                      {/* {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )} */}
                      {cell.getValue()}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className='h-2' />
      <div className='flex flex-column justify-content-end w-100 text-end'>
        <div className='text-end'>
          <button
            className='border rounded p-1'
            onClick={() => table.setPageIndex(0)}
            disabled={!table.getCanPreviousPage()}
          >
            {'<<'}
          </button>{' '}
          <button
            className='border rounded p-1'
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            {'<'}
          </button>{' '}
          <button
            className='border rounded p-1'
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            {'>'}
          </button>{' '}
          <button
            className='border rounded p-1'
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            disabled={!table.getCanNextPage()}
          >
            {'>>'}
          </button>{' '}
        </div>
      </div>
    </div>
  )
}
export default CrearRecursos
